import React ,{useEffect, useRef} from "react";
import './ContactUs.css';
import Navbar from "../Navbar/Navbar";

import LocationOnIcon from '@mui/icons-material/LocationOn';
import ChatIcon from '@mui/icons-material/Chat';
import CallIcon from '@mui/icons-material/Call';
import Contactphoto from './ContactusImages/contactphoto.png';
import Differentpills from './ContactusImages/differentpills.png';
import Contactustopimg from './ContactusImages/contactustopdiv.png';
import Pills from './ContactusImages/pills.png';

import Footer from "../Footer/Footer";

function ContactUs(){
    const renderOnlyOnce = useRef(false);
    useEffect(()=>{
        if(!renderOnlyOnce.current){
            window.scrollTo({behavior:'instant',top:0});
            renderOnlyOnce.current=true;
        }
    },[]);
    return(
        <>
            <div className="contactus-container">
                <Navbar/>
                {/* topdav */}
                <div className="contactus-topdiv">

                    <div className="contactus-topdiv-inner">
                        <div className="contactus-top-content">
                            <h3>contact us</h3>
                            <h2>Let Us Know How We Can <span style={{fontStyle:'italic',fontWeight:'300',color:'#015C8C'}}>Help</span></h2>
                            <p>Your health and satisfaction are important to us. Reach out to learn more about how we can help meet your healthcare needs with trusted expertise and empathy.</p>
                            <div className="contactus-top-content-pills">
                                <img src={Pills} alt='pills'/>
                            </div>
                        </div>
                        <div className="contactus-topdiv-images">

                            <div className="contactus-topdiv-main-img">
                                <img src={Contactustopimg} alt='main img'/>
                            </div>
                            <div className="contactus-topnav-differentpills">
                                <img src={Differentpills} alt='different pills'/>
                            </div>

                            {/* blur images */}
                            <div className="contactus-topdiv-imgblurs"></div>
                        </div>
                    </div>

                    {/* blurs */}
                    <div className="contactus-topdiv-blur1"></div>
                    <div className="contactus-topdiv-blur2"></div>
                    <div className="contactus-topdiv-blur3"></div>
                </div>

                {/* contact us form */}
                <div className="contactus-form">
                    <div  className="contactus-form-inner">
                        <div  className="contactus-form-div1">
                            <div>
                                <img src={Contactphoto} alt='contactphoto'/>
                            </div>
                        </div>
                        <form className="contactus-form-div2">
                            <h2>contact us</h2>
                            <div className="contactus-form-div2-double">
                                <div>
                                    <label>first name</label>
                                    <input type="text"/>
                                </div>
                                <div>
                                    <label>last name</label>
                                    <input type="text"/>
                                </div>
                            </div>
                            <div className="contactus-form-div2-single">
                                <label>email</label>
                                <input type='email'/>
                            </div>
                            <div className="contactus-form-div2-single">
                                <label>phone number</label>
                                <input type='number'/>
                            </div>
                            <div className="contactus-form-div2-single">
                                <label>message</label>
                                <textarea placeholder="Write Your Message Here..."/>
                            </div>
                            <button>Send Message</button>
                        </form>
                    </div>
                </div>
                {/* claa, chat, visit */}
                <div className="contactus-call-chat-visit">
                    <div className='ourvalues-inner'>
                        <div className="ourvalues-grid-container">
                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <CallIcon/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>call us</h2>
                                    <p>
                                        Mon - Sat From 8AM - 7 PM
                                    </p>
                                    <p>+ 91 9535876050</p>
                                </div>
                            </div>

                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <ChatIcon/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>chat us</h2>
                                    <p>Message to our friendly team</p>
                                    <p>lankarao@ardeslabs.com</p>
                                </div>
                            </div>

                            <div className="ourvalues-grid-item">
                                <div className="ourvalues-grid-item-img">
                                    <LocationOnIcon/>
                                </div>
                                <div className="ourvalues-grid-item-con">
                                    <h2>visit us</h2>
                                    <p>visit our office</p>
                                    <p>Plot No 103/B, Road No 9,ALEAP IndustrialArea,  Gajularamaram, Hyderabad-500090, Telangana.</p>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                {/* google map */}
                <div className="contactus-google-map">
                    <div className="contactus-googlemap-inner">
                        <div className="contactus-googlemap-div1">
                            <div>
                                <h2>1.Research & Development Centre</h2>
                                <p>Rd Number 9, ALEAP Industrial Area,Gajularamaram, Hyderabad,Telangana 500090</p>
                            </div>
                            <div>
                                <h2>2.Manufacturing Unit</h2>
                                <p>Plot no 3, JN Pharmacity,Tadi Village, Parawada,Visakhapatnam, Andhra Pradesh, India - 531019</p>
                            </div>
                            <div>
                                <h2>3.Manufacturing Unit</h2>
                                <p>Survey No 239A, 240/E,Dhotigudem, Pochampally,Yadadri, Bhuvanagiri, Telangana,India</p>
                            </div>

                        </div>
                        <div className="contactus-googlemap-div2">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d18780.527567178746!2d78.39542274859802!3d17.44552849850252!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bcb9115d1bdce55%3A0x40732e0724b4d734!2sSaanvika%20software%20solutions!5e0!3m2!1sen!2sin!4v1730617515126!5m2!1sen!2sin"
                                allowFullScreen=""
                                loading="lazy"
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Maps - Saanvika Software Solutions Location"
                            ></iframe>
                        </div>
                    </div>
                </div>
                
                {/* footer */}
                <Footer/>
                
            </div>
        </>
    );
}

export default ContactUs;